import axios, { AxiosInstance, AxiosError, AxiosResponse  } from 'axios'
import routes from "routes";
import {AUTH_STORAGE_KEY, getStorageData, removeStorageData} from "helpers/misc";

export const getBaseURL = () => {
  switch (process.env.REACT_APP_ENV) {
    case "local":
      return "http://localhost/v1/";
    case "dev":
      return "https://dev-api.sgtdocketrocket.com/v1/";
    default:
      return process.env.REACT_APP_API_HOST + "/v1/";
  }
};

const config = {
    baseURL: getBaseURL(),
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
}

const Axios: AxiosInstance = axios.create(config)

Axios.interceptors.request.use(
  config => {
    let authInfo = getStorageData(AUTH_STORAGE_KEY);
    authInfo?.access_token && !config.headers["Authorization"] && (config.headers["Authorization"] = `Bearer ${authInfo.access_token || ""}`);
    return config;
  }
);

Axios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    if ((error?.response?.status === 401 || error?.response?.status === 403) && window.location.pathname.indexOf("auth") < 0) {
      removeStorageData(AUTH_STORAGE_KEY);
      window.location.pathname = '/auth/' + routes.auth.login;
    }
    throw error;
  }
);

export default Axios
